// tippi/src/components/orderer/BillingProfileNotice.js
import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../../styles/tokens';

// Kompakt, ikke-blokkerende varsel om at fakturaopplysningene mangler, med lenke til skjemaet i profilen.
// Eieren bestemmer når det vises (se isBillingProfileComplete) og teksten.
export default function BillingProfileNotice({ children, style }) {
  return (
    <div role="status" style={{ ...styles.bar, ...style }}>
      <span style={styles.text}>{children}</span>
      <Link to="/orderer/profil#faktura" className="tippi-btn" style={styles.btn}>Fyll ut</Link>
    </div>
  );
}

const styles = {
  bar:  { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', borderRadius: 12, background: COLORS.warningBg, border: `1px solid ${COLORS.warningBorder}`, color: COLORS.warningText },
  text: { flex: 1, fontSize: 13, fontWeight: 600, lineHeight: 1.35 },
  btn:  { flexShrink: 0, padding: '6px 14px', borderRadius: 16, background: COLORS.accent, color: '#1a1a2e', fontSize: 13, fontWeight: 700, textDecoration: 'none' },
};
